module.exports = __webpack_public_path__ + "static/site-logo-4fbccca7fd264b5d840c16d1864945e3.png";